<template>
  <el-dialog 
      v-el-drag-dialog 
      title="选择边线库" 
      :visible.sync="dialogVisible" 
      class="adaptationModal" 
      append-to-body 
      width="800px">
    <div class="search">
      <el-input v-model="filter" style="width: 300px; margin-right: 10px" placeholder="请输入编码或名称过滤" clearable/>
      <el-button style="height: 29px" type="primary" @click="getData">查询</el-button>
    </div>
    <Table 
        :loading="loading" 
        row-key="id" 
        border 
        :columns="columns" 
        :data="tableData" 
        style="margin-top: 10px">
      <template slot="action" slot-scope="{ row }">
        <el-button type="primary" @click="selectLocation(row)">选择</el-button>
      </template>
    </Table>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        loading: false,
        tableData: [],
        filter: "",
        columns: [
          {
            title: "编码",
            key: "other",
            width: 300,
            tree: true,
          },
          {
            title: "名称",
            key: "label",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },

    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getData();
        });
      },

      getData() {
        this.loading = true;
        this.$http
          .get("basic", `warehouses/tree?filter=${this.filter}`)
          .then((res) => {
            if (res.success) {
              this.tableData = res.data;
              this.copyData = JSON.stringify(res.data);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },

      selectLocation(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },
    },
  };
</script>

<style lang="scss" scoped>
.search {
  background-color: #f4f7fa;
  padding: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  margin-bottom: 5px;
}
</style>
